import {Component, Input, OnInit} from '@angular/core';
import {ProjectCardModel} from "../../models/project-card.model";
import {QuickActionMenuModel} from "../../models/quick-action-menu.model";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-quick-actions-menu',
  templateUrl: './quick-actions-menu.component.html',
  styleUrls: ['./quick-actions-menu.component.scss']
})
export class QuickActionsMenuComponent implements OnInit {
  @Input() cardData: ProjectCardModel | undefined;
  @Input() vm$!: Observable<QuickActionMenuModel | null>;
  public baseUrl!: string;

  constructor() { }

  ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
  }

}
